import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  Pagination,
  Popconfirm,
  Table,
  Tag,
  Typography,
  message,
} from "antd";
import axiosInstance from "../../../../api/Axios";
import { DeleteTwoTone, UserOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";
import BulkCourseUsersAdd from "../../../../components/AdminComponents/Modals/BulkCourseUsersAdd";
import { useSelector } from "react-redux";
const { Title } = Typography;
const CourseUsers = (props) => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const userInfo = useSelector((state) => state.user);
  const [filterData, setFilterData] = useState({
    pageSize: 10,
    currentPage: 1,
    url: `/courseuserlist/`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, filter_url } = filterData;
  const [messageApi, contextHolder] = message.useMessage();
  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Trainer has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadUser();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove trainer.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    console.log("coming here", record.id, record);
    try {
      await axiosInstance.delete(`/learn/courseuserdelete/${record?.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const LoadAPI = () => {
    LoadUser();
  };
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `${id}/?page=${currentPage}&page_size=${pageSize}&search=${search}${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `${id}/?page=${currentPage}&page_size=${pageSize}${filter_url}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const columns = [
    {
      title: "Assignment ID",
      dataIndex: "assignment_id",
      key: "assignment_id",
      width: 135,
    },
    {
      title: "User Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.avatar || null}
            icon={!record?.avatar && <UserOutlined />}
            alt={record?.name}
            size="small"
          />
          <span>{record?.name}</span>
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "dep_name",
      key: "dep_name",
      width: 150,
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      align: "center",
      width: 150,
      render: (state) => {
        const stateColors = {
          Completed: { color: "#52c41a", borderColor: "#b7eb8f" },
          Pending: { color: "#ff4d4f", borderColor: "#ffa39e" },
          Ongoing: { color: "#faad14", borderColor: "#ffe58f" },
          Started: { color: "#faad14", borderColor: "#ffe58f" },
          Enrolled: { color: "#1890ff", borderColor: "#91d5ff" },
          Active: { color: "#52c41a", borderColor: "#b7eb8f" },
        };
        const style = stateColors[state] || { color: "#8c8c8c", borderColor: "#d9d9d9" };

        return (
          <Tag
            style={{
              color: style.color,
              borderColor: style.borderColor,
              backgroundColor: "transparent",
              borderRadius: "20px",
              fontWeight: "600",
              paddingInline: "15px",
              textAlign: "center",
              minWidth: "75px",
            }}
          >
            {state}
          </Tag>
        );
      },
    },
    {
      title: capitalizeWords("Enrolled On"),
      dataIndex: "enrolled_on",
      key: "enrolled_on",
      width: 150, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => formatDateWithSuffix(text),
    },

    ...(props?.ImpersonateAccess
      ? [
        {
          title: "Actions",
          dataIndex: "id",
          key: "id",
          align: "center",
          render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Popconfirm
                title={"Delete User"}
                description=" "
                onConfirm={() => handleDelete(record)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
                placement="leftTop"
              >
                <DeleteTwoTone
                  style={{
                    cursor: "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                  }}
                  title="Archive"
                  twoToneColor="#eb2f96"
                />
              </Popconfirm>
            </div>
          ),
        },
      ]
      : []),
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  useEffect(() => {
    if (id) {
      LoadUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, id]);

  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Users Summary
      </Title>
      <CommonTopDetails
        title={`Course Registrations`}
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkCourseUsersAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
      />
    </Card>
  );
};

export default CourseUsers;
